<script setup lang="ts">
import { DropdownMenuItem } from '../../ui/dropdown-menu'
import { Switch } from '../../ui/switch'
import type { Elemental } from '~~/src/types/elemental'
import { useKnowledgeBaseMutation } from '~~/src/composables/mutations/knowledge-base/useKnowledgeBaseMutation'

const { elemental } = defineProps<{
  elemental: Elemental
}>()

const { mutate: setKnowledgeBase, isPending } = useKnowledgeBaseMutation()

defineOptions({
  name: 'ElementalKnowledgeBase',
})

const isKnowledgeBase = ref(elemental.settings?.isKnowledgeBase ?? false)

const toggleIsKnowledgeBase = async () => {
  await setKnowledgeBase({ isKnowledgeBase: isKnowledgeBase.value, elemental })
}
</script>

<template>
  <DropdownMenuItem @select.prevent="">
    <div i-mdi:book-open-outline class="w-3 h-3" />
    Knowledge Base
    <Switch v-model:checked="isKnowledgeBase" size="xs" class="ml-auto" :disabled="isPending" :loading="isPending" :aria-disabled="isPending" @update:checked="toggleIsKnowledgeBase" />
  </DropdownMenuItem>
</template>
